module.exports = __webpack_public_path__ + "img/744.b79c5668.jpg";